import { render } from "./FormGroup.vue?vue&type=template&id=24a65fde&scoped=true&ts=true&lang=pug"
import script from "./FormGroup.vue?vue&type=script&lang=ts"
export * from "./FormGroup.vue?vue&type=script&lang=ts"

import "./FormGroup.vue?vue&type=style&index=0&id=24a65fde&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a65fde"]])

export default __exports__